import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../reducers/authSlice";
import counterReducer from "../reducers/counterSlice";
import iapReducer from "../reducers/iapSlice";
import bannerReducer from "../reducers/bannerSlice";
import assigmentReducer from "../reducers/assigmentSlice";
import assigmentLogReducer from "../reducers/assigmentLogSlice";
import accountReducer from "../reducers/accountSlice";
import categoriesReducer from "../reducers/categoriesSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  counter: counterReducer,
  iap: iapReducer,
  banner: bannerReducer,
  assigment: assigmentReducer,
  assigmentLog: assigmentLogReducer,
  account: accountReducer,
  category: categoriesReducer,
});

export default rootReducer;
